
import { computed, onBeforeMount, ref } from 'vue'
import { useStore } from 'vuex'
import TableComponentGeneric from '../TableComponentGeneric/TableComponentGeneric.vue'

export default {
    name: "OrderHistoryTable",
    components: {
        TableComponentGeneric
    },
    setup(){

        const store = useStore()

        const orderHistoryData = computed(() => {
            return store.state.order.display_order_history_table_data
        })

        const isAllOrdersShown = computed(() => {
            const lessItemsToShowThanDefaultTake = !(store.state.order.display_order_history_table_data.entries.length < store.state.order.order_history_take_amount)
            const isMaximumShownReached = !(store.state.order.display_order_history_table_data.entries.length === store.state.order.original_order_history_table_data.entries.length)
            return isMaximumShownReached && lessItemsToShowThanDefaultTake
        })

        const totalAmountOfEntries = computed(() => {
            return store.state.order.original_order_history_table_data.entries.length
        })

        const showMoreOrders = () => {
            store.dispatch('order/showMoreOrders')
        }

        const getLabel = (labelRequested) => {
            return store.getters['labels/getLabel'](labelRequested)
        }

        return {
            isAllOrdersShown,
            totalAmountOfEntries,
            getLabel,
            showMoreOrders,
            orderHistoryData
        }
    }
}